import {View} from 'react-native'
import {msg} from '@lingui/core/macro'
import {Trans, useLingui} from '@lingui/react/macro'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {atoms as a} from '#/alf'
import * as Layout from '#/components/Layout'
import {InlineLinkText} from '#/components/Link'
import {H1, P} from '#/components/Typography'

export function AboutScreen(
  _props: NativeStackScreenProps<CommonNavigatorParams, 'About'>,
) {
  const {t: l} = useLingui()
  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          <Layout.Header.TitleText>
            <Trans>About</Trans>
          </Layout.Header.TitleText>
        </Layout.Header.Content>
        <Layout.Header.Slot />
      </Layout.Header.Outer>
      <Layout.Content>
        <View style={[a.p_lg, a.gap_md]}>
          <H1 style={[a.text_5xl, a.font_semi_bold]}>
            <Trans>About Bunsky (this fork)</Trans>
          </H1>
          <P>
            <Trans>
              Bunsky is a soft fork of Bluesky's{' '}
              <InlineLinkText
                label={l(msg`Bluesky's social-app app on GitHub`)}
                to="https://github.com/bluesky-social/social-app">
                social-app
              </InlineLinkText>{' '}
              with some quality-of-life and style updates.
            </Trans>
          </P>
          <P>
            <Trans>
              There is no long-term guarantee that Bunsky will remain online
              indefinitely. Enjoy it if you want!
            </Trans>
          </P>
          <P>
            <Trans>This is really just a fun personal project {':)'}</Trans>
          </P>
        </View>
      </Layout.Content>
    </Layout.Screen>
  )
}
